import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingItalic: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m14 6l2-6H5L3 6h2.667l-1.334 4H2l-2 6h11l2-6h-2.667l1.334-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingItalic
